import { c as _c } from "react/compiler-runtime";
import { Button } from '@xefi/x-react/button';
import { Modal } from '@xefi/x-react/modal';
import { useTranslation } from 'react-i18next';
import { useGetSingleSurveyResponseReportMutation } from '@/app/survey/_hooks/useGetSingleSurveyResponseReportMutation';
import { useToasts } from '@/hooks/useToasts';
import type { SurveyTaking } from '@/models/survey';
import { downloadMedia } from '@/utils/common';
type ExpiredTimerModalProps = {
  currentSurvey: SurveyTaking;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  entryId?: string;
};
export const ExpiredTimerModal = t0 => {
  const $ = _c(33);
  const {
    currentSurvey,
    isOpen,
    setIsOpen,
    entryId
  } = t0;
  const {
    t
  } = useTranslation();
  const {
    addErrorToast
  } = useToasts();
  const getSingleSurveyResponseReportMutation = useGetSingleSurveyResponseReportMutation();
  const displayResult = currentSurvey.has_results_showed;
  let t1;
  if ($[0] !== addErrorToast || $[1] !== currentSurvey.id || $[2] !== getSingleSurveyResponseReportMutation || $[3] !== t) {
    t1 = responseId => {
      getSingleSurveyResponseReportMutation.mutate({
        responseId,
        surveyId: currentSurvey?.id
      }, {
        onSuccess: response => {
          downloadMedia(response, `response-report-${responseId}.pdf`, "application/pdf");
        },
        onError: () => {
          addErrorToast(t("response.pdfDownloaded.error", {
            ns: "notifications"
          }));
        }
      });
    };
    $[0] = addErrorToast;
    $[1] = currentSurvey.id;
    $[2] = getSingleSurveyResponseReportMutation;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleShowResult = t1;
  let t2;
  if ($[5] !== setIsOpen) {
    t2 = newOpen => {
      setIsOpen(newOpen);
    };
    $[5] = setIsOpen;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("survey.graded.expiredTimer.title");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== displayResult || $[10] !== entryId || $[11] !== handleShowResult || $[12] !== t) {
    t4 = displayResult && <Button radius="md" onClick={() => {
      if (!entryId) {
        return;
      }
      handleShowResult(entryId);
    }}>{t("survey.graded.showResult")}</Button>;
    $[9] = displayResult;
    $[10] = entryId;
    $[11] = handleShowResult;
    $[12] = t;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <div className="flex justify-end gap-2">{t4}</div>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg width="78" height="63" viewBox="0 0 78 63" fill="none" xmlns="http://www.w3.org/2000/svg" className="size-14"><path d="M27.1875 2.8125C27.1875 1.25391 28.4414 0 30 0C46.5703 0 60 13.4297 60 30C60 46.5703 46.5703 60 30 60C13.4297 60 0 46.5703 0 30C0 25.5586 0.960938 21.3516 2.69531 17.5664C3.39844 16.0195 4.23047 14.543 5.17969 13.1602L5.19141 13.1367C6.25781 11.5664 7.45312 10.1133 8.78906 8.78906C9.89062 7.6875 11.6719 7.6875 12.7617 8.78906C13.8516 9.89062 13.8633 11.6719 12.7617 12.7617C11.6836 13.8398 10.6992 15.0234 9.83203 16.2891L9.82031 16.3125C7.33594 19.9688 5.8125 24.3398 5.63672 29.0508C5.625 29.3672 5.61328 29.6836 5.61328 30C5.61328 43.4648 16.5234 54.375 29.9883 54.375C43.4531 54.375 54.3633 43.4648 54.3633 30C54.3633 17.4844 44.9414 7.18359 32.8008 5.78906V12.1875C32.8008 13.7461 31.5469 15 29.9883 15C28.4297 15 27.1758 13.7461 27.1758 12.1875V2.8125H27.1875ZM18.6328 18.6328C19.7344 17.5312 21.5156 17.5312 22.6055 18.6328L31.9805 28.0078C33.082 29.1094 33.082 30.8906 31.9805 31.9805C30.8789 33.0703 29.0977 33.082 28.0078 31.9805L18.6328 22.6055C17.5312 21.5039 17.5312 19.7227 18.6328 18.6328Z" fill="#2F2F2F" /><circle cx="58" cy="43" r="17" fill="white" /><path d="M58 24.5C62.9065 24.5 67.6116 26.4495 71.0811 29.9189C74.5505 33.3884 76.5 38.0935 76.5 43C76.5 47.9065 74.5505 52.6116 71.0811 56.0811C67.6116 59.5505 62.9065 61.5 58 61.5C53.0935 61.5 48.3884 59.5505 44.9189 56.0811C41.4495 52.6116 39.5 47.9065 39.5 43C39.5 38.0935 41.4495 33.3884 44.9189 29.9189C48.3884 26.4495 53.0935 24.5 58 24.5ZM58 48.75C57.8342 48.75 57.6748 48.8154 57.5576 48.9326C57.4404 49.0498 57.375 49.2092 57.375 49.375C57.375 49.5408 57.4404 49.7002 57.5576 49.8174C57.6748 49.9346 57.8342 50 58 50C58.1658 50 58.3252 49.9346 58.4424 49.8174C58.5596 49.7002 58.625 49.5408 58.625 49.375C58.625 49.2092 58.5596 49.0498 58.4424 48.9326C58.3252 48.8154 58.1658 48.75 58 48.75ZM58 36C57.9452 36 57.9062 36.039 57.9062 36.0938V43.5312C57.9062 43.586 57.9452 43.625 58 43.625C58.0548 43.625 58.0938 43.586 58.0938 43.5312V36.0938C58.0938 36.039 58.0548 36 58 36Z" fill="#EF4444" stroke="white" strokeWidth="3" /></svg>;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t) {
    t7 = t("survey.graded.expiredTimer.subtitle");
    $[17] = t;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t7) {
    t8 = <p>{t7}</p>;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== displayResult || $[22] !== t) {
    t9 = displayResult && <p className="w-full font-bold">{t("survey.graded.displayResult")}</p>;
    $[21] = displayResult;
    $[22] = t;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t8 || $[25] !== t9) {
    t10 = <div className="flex flex-col items-center gap-6 text-sm">{t6}{t8}{t9}</div>;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== isOpen || $[28] !== t10 || $[29] !== t2 || $[30] !== t3 || $[31] !== t5) {
    t11 = <Modal isOpen={isOpen} onOpenChange={t2} title={t3} footer={t5}>{t10}</Modal>;
    $[27] = isOpen;
    $[28] = t10;
    $[29] = t2;
    $[30] = t3;
    $[31] = t5;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
};